import {Chart, Grid, Header, styles, Surface, useTheme} from '../../tmwx-design-web/src';
import PortalStatisticsCard from '../../components/portal/PortalStatisticsCard';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "gui-common/redux/store";
import {useEffect} from "react";
import {ChartData, usePermissions} from "tmwx-design-common";
import {getMqttStatistics} from "gui-common/redux/action/efe/mqttStatisticsAction";
import {Company} from "gui-common/redux/data/company";
import {Device} from "gui-common/redux/data/device";
import {getDeviceList} from "gui-common/redux/action/efe/deviceAction";

const EfeDashboard = () => {
    const { roundness, padding } = useTheme()
    const { t } = useTranslation()
    const dispatch: any = useDispatch();
    const { hasRights } = usePermissions()
    const deviceList = useSelector<RootState, Device[]>(state => state.device.deviceList);
    const incomingMsgs = useSelector<RootState, ChartData[]>(state => state.mqttStatistics.incomingMsgs);
    const subscriptions = useSelector<RootState, ChartData[]>(state => state.mqttStatistics.subscriptions);
    const connectedCount = useSelector<RootState, number>(state => state.mqttStatistics.connectedCount);
    const activeCompany = useSelector<RootState, Company>(state => state.auth.activeCompany);

    useEffect(() => {
        if (hasRights(["efe_efe_list"]) && activeCompany.id !== undefined) {
            dispatch(getDeviceList(activeCompany.id))
        }

        if (hasRights(["efe_dashboard_view"])) {
            dispatch(getMqttStatistics())
        }
    }, [dispatch, activeCompany])

    return (
        <Surface style={{ height: '100vh', paddingTop: 8, paddingBottom: 8 }}>
            <Grid.Container style={{ borderRadius: roundness }} maxWidth='xl' elevation={0} centered>
                <Grid.Col m={6} lg={6} xl={6}>
                    <PortalStatisticsCard
                        iconName='done_outline'
                        title={t('efe.numOfRegistered')}
                        description={t('efe.numOfRegisteredText')}
                        value={deviceList.length}
                    />
                </Grid.Col>

                <Grid.Col m={6} lg={6} xl={6}>
                    <PortalStatisticsCard
                        iconName='link'
                        title={t('efe.numOfConnected')}
                        description={t('efe.numOfConnectedText')}
                        value={connectedCount}
                    />
                </Grid.Col>

                {incomingMsgs.length > 0 &&
                    <Grid.Col m={6} lg={6} xl={6}>
                        <Surface rounded>
                            <Header
                                title={t('efe.incomingMsgs')}
                                rounded
                            />

                            <Surface style={{ padding: padding, paddingTop: 0, overflowX: 'auto' }} rounded>
                                <Chart.Line
                                    style={styles.marginTop16}
                                    data={incomingMsgs}
                                />
                            </Surface>
                        </Surface>
                    </Grid.Col>
                }

                {subscriptions.length > 0 &&
                    <Grid.Col m={6} lg={6} xl={6}>
                        <Surface rounded>
                            <Header
                                title={t('efe.subscriptions')}
                                rounded
                            />

                            <Surface style={{ padding: padding, paddingTop: 0, overflowX: 'auto' }} rounded>
                                <Chart.Line
                                    style={styles.marginTop16}
                                    data={subscriptions}
                                />
                            </Surface>
                        </Surface>
                    </Grid.Col>
                }
            </Grid.Container>
        </Surface>
    );
};

export default EfeDashboard;